<consumer-report-question-form [model]="model"></consumer-report-question-form>